import styled from 'styled-components';
import { borderColor } from 'Public/css/colors';
import { Select } from "antd";

export default styled(Select) `
    
    height: 50px;
    
    .ant-select-selector {
        border: solid 1px ${ borderColor };
        border-radius: 4px !important;
        font-size: 16px;
        padding-top: 11px;
        padding-bottom: 10px;
        min-height: 48px !important ;
      
        .ant-select-selection-item, .ant-select-selection-placeholder {
            line-height: 46px;
        }
    }

   &.ant-select:not(.ant-select-customize-input) .ant-select-selector {
       border: solid 1px ${ borderColor };
   }
    
    .ant-select-selection-overflow-item .ant-select-selection-item {
        line-height: 22px;
    }
  
    &.height38 {
      width: 100%;
      height: 42px;

        .ant-select-selector {
          height: 42px !important ;
      }
      .ant-select-selection-placeholder {
          line-height: 40px;      
      }
    }

    &.ant-select-single:not(.ant-select-customize-input) .ant-select-selector .ant-select-selection-search-input {
        height: 46px;
    }
`;
